import React from 'react';
import { Body, VStack } from '@hover/blueprint';

export const DescriptionLatest: React.FC = () => (
  <VStack
    spacing={600}
    alignItems="flex-start"
    mb={{ base: 900, tablet: '56px' }}
  >
    <Body>
      HOVER provides 3D property data and other services. This Privacy Policy is
      intended to help you understand what personal information we collect, how
      we use and share that information, and how you can make choices regarding
      your personal information. The Policy applies to all services provided or
      powered by HOVER, including websites, mobile applications, co-branded or
      white-labled sites and apps, and products that are integrated into
      third-party apps and sites, like embedded 3D visualizers.
    </Body>
  </VStack>
);
